function CategoriesBlock({
  categories,
  handleCategoryChange,
  language,
  category,
  filter,
}) {
  const localizedFilter = [
    { key: "", de: "Alle", en: "All" },
    ...categories.filter((item) => filter.indexOf(item.key) !== -1),
  ];
  return (
    <div className="global-news__categories">
      {localizedFilter.map((cat) => (
        <button
          className={`btn bg-${cat.key === category ? "blue" : "lighter-gray"}`}
          key={cat.key}
          onClick={() => handleCategoryChange(cat.key)}
        >
          {cat[language]}
        </button>
      ))}
    </div>
  );
}

export default CategoriesBlock;
